function _etleeLoading() {
  $("#preloader" ).fadeOut("fast");
}

// HOMEPAGE COLLECTIONS
document.addEventListener("DOMContentLoaded", function() {
  _etleeLoading();
  // ================ HEADER  =================
  const header = document.querySelector(".header");
  let ticking = false;

  let pageType = $("header").attr("data-page-type");
  if (pageType === "index") {
    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (window.scrollY > 50) {
            header.classList.add("scrolled");
            header.classList.remove("header-homepage__top");
          } 
          else 
          {
            header.classList.remove("scrolled");
            header.classList.add("header-homepage__top");
          }
          ticking = false;
        });
        ticking = true;
      }
    });
  }
  // ================ END HEADER =================

  // ================ LEFT MENU  =================
  const openMenuBtns = document.querySelectorAll(".openMenuBtn");
  const closeMenuMobileBtn =
    document.getElementById("closeMenuMobileBtn");
  const popupOverlay = document.getElementById("popupOverlay");
  const popupMenu = document.getElementById("popupMenu");
  const rightColWrapper = document.getElementById(
    "rightColContentWrapper"
  );
  const linkItems = $(
    ".nav-link-item[data-tab], .menu-fixed-link[data-tab]"
  );

  const isMobile = () => window.innerWidth < 768;

  function resetActiveStates() {
    $(".nav-link-item, .menu-fixed-link").removeClass("active-pc");
    $(".mobile-dropdown-content a.active-mobile-link").removeClass(
      "active-mobile-link"
    );
  }

  function toggleMenu(show) {
    if (show) {
      popupOverlay.classList.add("active");
      popupMenu.classList.add("active");
      // if (!isMobile()) {
      //   showPCContent("collection");
      // }
      document.body.style.overflow = "hidden";
    } else {
      popupOverlay.classList.remove("active");
      popupMenu.classList.remove("active");
      rightColWrapper.classList.remove("show");

      document.body.style.overflow = "";

      resetActiveStates();
      // close all dropdown when menu close
      $(".mobile-dropdown-content:visible").slideUp(300);
    }
  }

  function showPCContent(tabName) {
    $("#menuRightCol").fadeIn();
    const tabContents = $(".tab-content");

    rightColWrapper.classList.remove("show");
    tabContents.addClass("d-none");
    resetActiveStates();

    const activeContent = $(`.tab-content[data-content="${tabName}"]`);
    if (activeContent.length) {
      activeContent.removeClass("d-none");
    }

    const activeLink = $(`[data-tab="${tabName}"]`);
    if (activeLink.length) {
      activeLink.addClass("active-pc");
    }

    setTimeout(() => {
      rightColWrapper.classList.add("show");
    }, 10);
  }

  // open/close menu
  openMenuBtns.forEach((btn) => {
    btn.addEventListener("click", () => toggleMenu(true));
  });
  closeMenuMobileBtn.addEventListener("click", () => toggleMenu(false));
  popupOverlay.addEventListener("click", (e) => {
    if (e.target === popupOverlay && !isMobile()) {
      $("#menuRightCol").hide();
      toggleMenu(false);
    }
  });

  // (Tab/Dropdown)
  linkItems.on("click", function (e) {
    const $link = $(this);
    const tabName = $link.data("tab");
    const isDropdown = $link.hasClass("nav-link-item");

    if (isMobile()) {
      if (isDropdown) {
        const $dropdown = $link.next(".mobile-dropdown-content");

        // close others dropdown
        $(".mobile-dropdown-content").not($dropdown).slideUp(400);

        // Toggle current dropdown
        $dropdown.slideToggle(400);

        $link.toggleClass("active-pc", $dropdown.is(":hidden"));
      }

      $(".nav-link-item, .menu-fixed-link").removeClass("active-pc");
      $link.addClass("active-pc");

      $(".mobile-dropdown-content a.active-mobile-link").removeClass(
        "active-mobile-link"
      );
    } else {
      if (
        tabName === "collection" ||
        tabName === "note" ||
        tabName === "size"
      ) {
        showPCContent(tabName);
      } else {
        resetActiveStates();
        $link.addClass("active-pc");
        $(".tab-content").addClass("d-none");
        rightColWrapper.classList.remove("show");
      }
    }
  });

  $(".mobile-dropdown-content a.mobile-link").on("click", function (e) {
    if (isMobile()) {
      // e.preventDefault();
      $(".mobile-dropdown-content a.active-mobile-link").removeClass(
        "active-mobile-link"
      );
      $(this).addClass("active-mobile-link");
    }
  });

  $(window).on("resize", () => {
    if (isMobile()) {
      $(".nav-link-item, .menu-fixed-link").removeClass("active-pc");
    } else {
      if (popupMenu.classList.contains("active")) {
        // showPCContent("collection");
        $(".mobile-dropdown-content").hide();
      }
    }
  });
  // ================ END LEFT MENU =================

  //=============== HOME PAGE COLLECTION =============
  // ---------------- DESKTOP JS ----------------
  const desktopCollections = document.querySelector('.collections-desktop .collections');
  const desktopImages = document.querySelectorAll('.collections-desktop .collection-card img');

  function resizeDesktopImages() {
    if (!desktopCollections) return;
    const collWidth = desktopCollections.offsetWidth;
    if (window.innerWidth > 768) {
      desktopImages.forEach(img => {
        img.style.width = (collWidth * 0.75) + 'px';
        img.style.height = 'auto';
        img.style.top = '50%';
        img.style.transform = 'translate(-50%, -50%)';
      });
    }
  }
  resizeDesktopImages();
  window.addEventListener('resize', resizeDesktopImages);

  // ---------------- MOBILE JS ----------------
  const mobileCards = document.querySelectorAll('.collection-card-mobile');
  mobileCards.forEach(card => {
    card.addEventListener('click', function (e) {
      if (this.classList.contains('active')) {
        // this.classList.remove('active');
        return;
      } else {
        e.preventDefault();
        mobileCards.forEach(c => c.classList.remove('active'));
        this.classList.add('active');
      }
    });
  });
  //=============== END HOME PAGE COLLECTION =============


  //================ HOMEPAGE SLIDER ==============
  if (document.querySelectorAll(".homepage-swiper").length) {
    let productSwiper = new Swiper(".homepage-swiper", {
      spaceBetween: 20,
      slidesPerView: 3.8,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 30,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      slideToClickedSlide: true,
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 0,
        }
      },
      on: {
        init: function () {
          updateSlideCursor(this);
        },
        slideChange: function () {
          updateSlideCursor(this);
        },
        resize: function () {
          updateSlideCursor(this);
        }
      }
    });

    // Class assignment function based on data-swiper-slide-index (loop support)
    function updateSlideCursor(swiper) {
      if (!swiper || !swiper.slides) return;

      const slides = Array.from(swiper.slides); 
      const indices = slides
        .map(s => parseInt(s.getAttribute('data-swiper-slide-index')))
        .filter(n => !isNaN(n));
      if (indices.length === 0) return;

      const N = Math.max(...indices) + 1; // real product total
      const realIndex = typeof swiper.realIndex === 'number' ? swiper.realIndex : 0;

      slides.forEach(slide => {
        slide.classList.remove('cursor-left','cursor-right','cursor-center');
        const idx = parseInt(slide.getAttribute('data-swiper-slide-index'));
        if (isNaN(idx)) return;

        let diff = idx - realIndex;
        if (diff > N/2) diff -= N;
        if (diff <= -N/2) diff += N;

        // set 2 products on left/right =>  -2..-1 are left, 1..2 are right
        if (diff === 0) {
          slide.classList.add('cursor-center');
        } else if (diff > 0 && diff <= 2) {
          // right slide of active => show left arrow
          slide.classList.add('cursor-left');
        } else if (diff < 0 && diff >= -2) {
          // left slide of active => show right arrow
          slide.classList.add('cursor-right');
        }
      });
    }

    productSwiper.on('transitionEnd', function () {
      updateSlideCursor(this);
    });
  }



  if (document.querySelectorAll(".homepage-banner-swiper").length) {
    let bannerSwiper = new Swiper(".homepage-banner-swiper", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      loop: true,
      slideToClickedSlide: true,
    });
  }

  if (document.querySelectorAll(".allProductSwiper").length) {
    let allProductSwiper = new Swiper(".allProductSwiper", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      loop: true,
      slideToClickedSlide: true,
    });
  }

  //=============== ABOUT ETLEE SECTION ==================
  if ($(".section-about-item").length) {
    const aboutSections = document.querySelectorAll(".section-about-item");

    aboutSections.forEach((item) => {
      const bg = item.querySelector(".section-about-bg");
      const bgActive = item.querySelector(".section-about-bg-active");
      const defaultImg = item.dataset.aboutDefault;
      const activeImg = item.dataset.aboutActive;

      if (bg) {
        bg.style.backgroundImage = `url(${defaultImg})`;
      }
      if (bgActive) {
        bgActive.style.backgroundImage = `url(${activeImg})`;
      }

      // Hover for PC
      item.addEventListener("mouseenter", () => {
        if (window.innerWidth > 768) item.classList.add("active");
      });
      item.addEventListener("mouseleave", () => {
        if (window.innerWidth > 768) item.classList.remove("active");
      });

      // Toggle for mobile
      item.addEventListener("click", (e) => {
        if (window.innerWidth <= 768) {
          e.stopPropagation();
          const isActive = item.classList.contains("active");
          aboutSections.forEach((s) => s.classList.remove("active"));
          if (!isActive) item.classList.add("active");
        }
      });
    });
  }

  // Click outside to close (mobile)
  document.addEventListener("click", (e) => {
    if (window.innerWidth <= 768) {
      const clickedItem = e.target.closest(".section-about-item");
      if (!clickedItem && clickedItem != null)
        aboutSections.forEach((s) => s.classList.remove("active"));
    }
  });

  //============== CHECK MAIL FOOTER================
  const form = document.querySelector(".footer-form");
  const input = form.querySelector("input");
  const message = form.querySelector(".subscribe-message");

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    const email = input.value.trim();

    if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showMessage(`Thank you for subscribing, ${email}!`, "success");

      // reset input & remove error state
      this.reset();
    } else {
      showMessage("Please enter a valid email address.", "error");
    }
  });

  input.addEventListener("input", () => {
    const email = input.value.trim();
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      message.classList.remove("show", "subscribe-error");
      message.textContent = "";
    }
  });

  function showMessage(text, type) {
    message.textContent = text;
    message.className = `subscribe-message show ${
      type === "success" ? "subscribe-success" : "subscribe-error"
    }`;

    if (type === "success") {
      setTimeout(() => {
        message.classList.remove("show", "subscribe-success");
        message.textContent = "";
      }, 3000);
    }
  }



  // ============ POPUP FILTER ===============
  const openFilterBtn = document.getElementById("openFilterBtn");
  const closeFilterBtn = document.getElementById("closeEtleeFilterBtn");
  const filterOverlay = document.getElementById("etleeFilterOverlay");
  const filterPopup = document.getElementById("etleeFilter");
  const filterRightWrapper = document.getElementById("etleeFilterRightWrapper");

  function resetFilterStates() {
    $(".etlee-filter-tab").removeClass("active-filter");
    $(".etlee-filter-dropdown a.active-mobile-link").removeClass("active-mobile-link");
  }

  function resetSortStates() {
    $(".etlee-sort-tab").removeClass("active-filter");
  }

  function toggleFilter(show) {
    if (show) {
      filterOverlay.classList.add("active");
      filterPopup.classList.add("active");
      // if (!isMobile()) showFilterPC("collection");
      document.body.style.overflow = "hidden";
    } else {
      $("#etleeFilterRightCol").hide();
      filterOverlay.classList.remove("active");
      filterPopup.classList.remove("active");
      filterRightWrapper.classList.remove("show");
      document.body.style.overflow = "";
      resetFilterStates();
      resetSortStates();
      $(".etlee-filter-dropdown:visible").slideUp(300);
    }
  }

  function showFilterPC(tabName) {
    $("#etleeFilterRightCol").fadeIn();
    const tabContents = $(".etlee-filter-content");
    filterRightWrapper.classList.remove("show");
    tabContents.addClass("d-none");
    resetFilterStates();

    const activeContent = $(`.etlee-filter-content[data-content="${tabName}"]`);
    if (activeContent.length) activeContent.removeClass("d-none");

    const activeLink = $(`[data-tab="${tabName}"]`);
    if (activeLink.length) activeLink.addClass("active-filter");

    setTimeout(() => filterRightWrapper.classList.add("show"), 10);
  }

  if (openFilterBtn) {
    openFilterBtn.addEventListener("click", () => toggleFilter(true));
  }
  if (closeFilterBtn) {
    closeFilterBtn.addEventListener("click", () => toggleFilter(false));
  }
  if (filterOverlay) {
    filterOverlay.addEventListener("click", (e) => {
      if (e.target === filterOverlay && !isMobile()) toggleFilter(false);
    });
  }

  // ========== FILTER TAB ==========
  $(".etlee-filter-tab").on("click", function () {
    const $link = $(this);
    const tabName = $link.data("tab");

    if (isMobile()) {
      const $dropdown = $link.next(".etlee-filter-dropdown");
      $(".etlee-filter-dropdown").not($dropdown).slideUp(400);
      $dropdown.slideToggle(400);
      $(".etlee-filter-tab").removeClass("active-filter");
      $link.addClass("active-filter");
    } else {
      if (["collection", "note", "size"].includes(tabName)) showFilterPC(tabName);
      else {
        resetFilterStates();
        $link.addClass("active-filter");
        $(".etlee-filter-content").addClass("d-none");
        filterRightWrapper.classList.remove("show");
      }
    }
  });

  // ========== SORT TAB ==========
  $(".etlee-sort-tab").on("click", function () {
    const $link = $(this);
    $(".etlee-sort-tab").removeClass("active-filter");
    $link.addClass("active-filter");
  });

  // ========== MOBILE FILTER LINK ==========
  $(".etlee-filter-dropdown a.etlee-filter-link").on("click", function (e) {
    if (isMobile()) {
      // e.preventDefault();
      $(".etlee-filter-dropdown a.active-mobile-link").removeClass("active-mobile-link");
      $(this).addClass("active-mobile-link");
    }
  });

  // ========== RESPONSIVE ==========
  $(window).on("resize", () => {
    if (isMobile()) {
      $(".etlee-filter-tab").removeClass("active-filter");
      $(".etlee-sort-tab").removeClass("active-filter");
    } else if (filterPopup.classList.contains("active")) {
      // showFilterPC("collection");
      $(".etlee-filter-dropdown").hide();
    }
  });

  // =================== FILTER SELECTION (MOBILE + PC) ===================
  let selectedFilter = null;
  let selectedSort = null;

  // set filter func (mobile + PC)
  function setFilterSelection($link, url) {
    // clear active state ở cả mobile + PC
    $(".etlee-filter-dropdown a.etlee-filter-link, #etleeFilterRightCol a.etlee-filter-link")
      .removeClass("active-mobile-link active-pc-link");

    // active
    if (isMobile()) {
      $link.addClass("active-mobile-link");
    } else {
      $link.addClass("active-pc-link");
    }

    selectedFilter = url;
  }

  // ========== MOBILE FILTER CLICK ==========
  $(document).on("click", ".etlee-filter-dropdown a.etlee-filter-link", function (e) {
    e.preventDefault();
    const $link = $(this);
    const url = $link.attr("href");
    setFilterSelection($link, url);
  });

  // ========== PC FILTER CLICK  ==========
  $(document).on("click", "#etleeFilterRightCol a.etlee-filter-link", function (e) {
    e.preventDefault();
    const $link = $(this);
    const url = $link.attr("href");
    setFilterSelection($link, url);
  });

  // ========== SORT CLICK ==========
  $(document).on("click", ".etlee-sort-tab", function (e) {
    e.preventDefault();
    const $link = $(this);
    const url = $link.attr("href");

    $(".etlee-sort-tab").removeClass("active-filter");
    $link.addClass("active-filter");
    selectedSort = url;
  });

  // ========== SHOW RESULTS ==========
  $(".result-button").on("click", function () {
    let finalUrl = "";

    if (selectedFilter && selectedSort) {
      const hasQuery = selectedFilter.includes("?");
      finalUrl = selectedFilter + (hasQuery ? "&" : "?") + selectedSort.split("?")[1];
    } else if (selectedFilter) {
      finalUrl = selectedFilter;
    } else if (selectedSort) {
      finalUrl = selectedSort;
    }

    if (finalUrl) {
      window.location.href = finalUrl;
    } else {
      // alert("Please select a filter or sort option first.");
    }
  });

  // ========== RESET ==========
  $(".reset-button").on("click", function () {
    selectedFilter = null;
    selectedSort = null;
    $(".etlee-filter-link").removeClass("active-mobile-link active-pc-link");
    $(".etlee-sort-tab").removeClass("active-filter");
  });
  // ============ END POPUP FILTER ===============

});


